<template>
  <el-dialog width="45%" title="培训码具体规则" :visible.sync="detailRuleVisible" append-to-body>
    <div>
      <div class="title">1、近五年集中培训学时分码规则：</div>
      <div class="desc">{{ '1）绿码：实际学时 ≥ 学时要求；' }}</div>
      <div class="desc">{{ `2）黄码：学时要求/3 ≤ 实际学时 ＜ 学时要求；` }}</div>
      <div class="desc">{{ '3）红码：实际学时 ＜ 学时要求/3；' }}</div>
      <div class="desc">{{ '4）达标要求：县处级及以上，达标要求110学时/年，五年550学时；县处级以下，达标要求90学时/年，五年450学时；从提任处级当年开始，按110学时/年计算；' }}</div>
      <div class="desc">{{ '5）当前完成数值颜色=分码颜色，如果数值颜色为黑色，代表该培训任务不影响培训码颜色。' }}</div>
      <div class="title">2、本年度网络自学学时分码规则：</div>
      <div class="desc">{{ '1）绿码：10月以前，统一绿码；10月起，实际学时 ≥ 学时要求/2；12月起，实际学时 ≥ 学时要求*3/4；12月15日起，实际学时 ≥ 学时要求；' }}</div>
      <div class="desc">{{ '2）黄码：10月起，学时要求/4 ≤ 实际学时 ＜ 学时要求/2；12月起，学时要求/2 ≤ 实际学时 ＜ 学时要求*3/4；' }}</div>
      <div class="desc">{{ '3）红码：10月起，实际学时 ＜ 学时要求/4；12月起，实际学时 ＜ 学时要求/2；12月15日起，实际学时 ＜ 学时要求；' }}</div>
      <div class="desc">4）达标要求:各分院在管理后台考核规则模块配置;并与用户考核开始时间相关。</div>
      <div class="desc">5）当前完成数值颜色=分码颜色，如果数值颜色为黑色，代表该培训任务不影响培训码颜色。</div>
      <div class="title">3、培训码总码规则</div>
      <div class="title2">3.1 考核用户</div>
      <div class="desc">1）如果对应干部级别有2个培训任务：结合以上2个分码颜色，取2者中较低的分码颜色。如近五年集中培训学时分码为红码，本年度网络自学学时分码颜色为绿码，则总码颜色为红码；</div>
      <div class="desc">2）如果对应干部级别只有1个培训任务：总码颜色与分码颜色一致；</div>
      <div class="desc">3）如果对应干部级别未设置培训任务：总码颜色始终为灰色；</div>
      <div class="title2">3.2 不考核用户</div>
      <div class="desc">总码颜色始终为灰色。</div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" size="small" @click="close" >确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      detailRuleVisible: false,
    };
  },
  created() { },
  activated() { },
  computed: {},
  methods: {
    show() {
      this.detailRuleVisible = true;
    },
    close() {
      this.detailRuleVisible = false;
    }
  },
};
</script>
<style lang='scss' scoped>
.title {
  margin-top: 10px;
  font-weight: bold;
  color: #000;
  font-size: 16px;
  line-height: 28px;
}
.title2 {
  margin-top: 4px;
  font-weight: bold;
  color: #000;
  margin-left: 16px;
  line-height: 24px;
}
.desc {
  margin-left: 16px;
  line-height: 20px;
}
/deep/.el-dialog__body {
  padding: 20px !important;
}
</style>